import { render, staticRenderFns } from "./CenteredContentLayout.vue?vue&type=template&id=33472349&scoped=true&"
import script from "./CenteredContentLayout.vue?vue&type=script&lang=js&"
export * from "./CenteredContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./CenteredContentLayout.vue?vue&type=style&index=0&id=33472349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33472349",
  null
  
)

export default component.exports